import { OrderStepConfig } from '@models/order-step';
import { ProductAdviceTabletComponent } from 'app/products/tablet-plus/steps/product-advice-tablet/product-advice-tablet.component';

export const productAdviceTablet: OrderStepConfig = {
    slug: 'produktberatung',
    component: ProductAdviceTabletComponent,
    title: 'Produktberatung',
};
